import React from 'react';
import styled from 'styled-components';
import {withRouter} from 'react-router-dom';

import {useApi} from '../../lib/api';
import {withUser} from '../../lib/user';
import Card from '../../components/Card';
import ListItem from '../../components/ListItem';
import TimeAgo from '../../components/TimeAgo';
import {T} from '../../components/I18n';

import NoNotificationsIcon from './no-notifications.svg';
import { UserLink } from '../../components/UserLink';

function NotificationList({notifications, history}) {
  const api = useApi();

  function SheetRowReviewNotification(notification) {
    return {
      actions: [
        {
          title: 'Review', 
          onClick: () => {
            api.markNotificationAsRead(notification.id);
            history.push(`/sheet/${notification.metadata.templateId}/${notification.metadata.sheetId}/data/${notification.metadata.sheetRowId}`);
          }
        }
      ],
      render: (
        <T isolate><UserLink user={notification.from} /> submitted data to <strong><T variable="formname">{notification.metadata.templateName}</T></strong> for review.</T>
      )
    }
  }

  const notificationRegistry = {
    'sheet_row_review_request': SheetRowReviewNotification
  };

  return (
    <CardContainer>
      <Card.Title>Notifications</Card.Title>
      {notifications.length < 1 ? (
        <Card.Content>
          <NoNotifications>
            <img src={NoNotificationsIcon} alt="" />
            <h3>All caught up!</h3>
            <p>New notifications will appear here.</p>
          </NoNotifications>
        </Card.Content>
      ) : notifications.map(notification => {
        const handler = notificationRegistry[notification.type](notification);

        return (
          <Notification
            key={notification.id}
            unread={!notification.read}
            subtitle={<TimeAgo date={notification.timestamp} />}
            options={handler.actions}>
            {handler.render}
          </Notification>
        );
      })}
    </CardContainer>
  );
}

const CardContainer = styled(Card)`
  margin-bottom: 2rem;
`;

const NoNotifications = styled.div`
  text-align: center;

  h3 {
    margin: 1rem 0 0.5rem 0;
    font-size: 1.4rem;
    font-weight: 500;
  }

  p {
    padding: 0.5rem 0;
    margin: 0;
  }
`;

const Notification = styled(ListItem)`
  background: ${props => props.unread ? '#edf2fa' : 'white'};
`;

export default withRouter(withUser(NotificationList));